import React from "react";
import { Modal, Input, notification, Form } from "antd";
import { useMutation } from "@apollo/react-hooks";
import { SaveFrOrganizer } from "../../../graphql/organization";

export const FrOrganizerDlg = ({ model, onClose }) => {
  const [form] = Form.useForm();
  const [saveFrOrganizer, { loading: saving }] = useMutation(SaveFrOrganizer);

  const save = () => {
    form.validateFields().then((values) => {
      // let list = Store.orgs.filter(
      //   (x) =>
      //     x.id !== model.id && x.state === model.state && x.city === model.city
      // );
      // if (list.filter((x) => x.name === model.name).length > 0) {
      //   form?.current?.setError(
      //     "name",
      //     "Duplicate organization name. Please try using another name."
      //   );
      //   return;
      // } else if (list.filter((x) => x.nickName === model.nickName).length > 0) {
      //   form?.current?.setError(
      //     "nickName",
      //     "Duplicate nickname. Please try using another nickname."
      //   );
      //   return;
      // }
      saveFrOrganizer({
        variables: { input: { id: model.id, orgId: model.orgId, ...values } },
      }).then((res) => {
        notification.success({ message: `Fundraiser Organization ${values.name} saved` });
        onClose();
      });
    });
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  const onValuesChange = (values) => {};

  return (
    <Modal
      title="Fundraiser Organization"
      visible={true}
      onOk={() => save()}
      maskClosable={false}
      confirmLoading={saving}
      onCancel={() => onClose()}
    >
      <Form form={form} {...layout} initialValues={{ ...model }} onValuesChange={onValuesChange}>
        <Form.Item label="Full Name" name="name" rules={[{ required: true, message: "Please input full name" }]}>
          <Input placeholder="Enter full name" />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input placeholder="Enter description" />
        </Form.Item>
        <Form.Item label="Contact Name" name="contactName">
          <Input placeholder="Enter contact name" />
        </Form.Item>
        <Form.Item label="Contact Phone" name="contactPhone">
          <Input placeholder="Enter contact phone" />
        </Form.Item>
        <Form.Item label="Contact Email" name="contactEmail">
          <Input placeholder="Enter contact email" />
        </Form.Item>
        <Form.Item label="Bank Routing" name="bankRouting">
          <Input placeholder="Enter bank routing account number" />
        </Form.Item>
        <Form.Item label="Bank Account" name="bankAccount">
          <Input placeholder="Enter bank account number" />
        </Form.Item>
        {/* <Form.Item label="Permissioned Fundraiser" name="admins" rules={[{ required: true, message: "Please select" }]}>
          <Input placeholder="Enter bank account number" />
        </Form.Item> */}
      </Form>
    </Modal>
  );
};
